import { type LigneMouvement, Nature, Section } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import CodeProduitLocalPanel from '../../panel/CodeProduitLocalPanel';
import CompteDeTiersPanel from '../../panel/CompteDeTiersPanel';
import CovidPanel from '../../panel/CovidPanel';
import MandatEmisApresPaiementPanel from '../../panel/InformationsRattachement/MandatEmisApresPaiementPanel';
import PeriodeCouvertePanel from '../../panel/PeriodeCouvertePanel';
import ProjetPanel from '../../panel/ProjetPanel';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';

class ProfilEcritureFonctionnementEmisApresEncaissementRecette extends BaseProfilRattachement {
	constructor(anneeExercice: number) {
		super();
		this.code = PROFIL_ECRITURE.RECETTE.FONC_EMIS_APRES_ENCAISSEMENT;
		this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.RECETTE.FONCTIONNEMENT;
		this.typePiece = TYPE_PIECE.RECETTE.EMIS_APRES_PAIE;
		this.naturePieceOrigine = NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.CODE;
		this.exerRattachement = anneeExercice.toString();
		this.imputation.nature = Nature.REEL;
		this.imputation.section = Section.FONCTIONNEMENT;
		this.idLigneOriginePes = 0;
		this.panels = [
			new CodeProduitLocalPanel(true),
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new MandatEmisApresPaiementPanel(true),
			new PeriodeCouvertePanel(),
			new ProjetPanel(),
		];
	}

	checkLigne(ligne: LigneMouvement): ErrorField[] {
		return [
			...super.checkLigne(ligne),
			...this.checkExerRattachementAnterieurOuEgal(ligne),
			...this.checkIdLigneOriginePesNul(ligne),
		];
	}
}
export default ProfilEcritureFonctionnementEmisApresEncaissementRecette;
